import {CUSTOMER, POST_UPDATE_BIRTH_INFOS_TIERS} from '../../../../actions/app/customer/customer.actions'
import {API_ERROR, API_SUCCESS, apiRequest} from '../../../../actions/core/api/api.actions'
import {setError, setLoader} from '../../../../actions/app/ui/ui.actions'
import {setNotification} from '../../../../actions/core/notifications/notifications.actions'
import {clearContracts, CONTRACTS, setContracts} from "../../../../actions/app/contracts/contracts.actions";

export const customerUpdatebirthinfosMiddleware = () => next => action => {
    next(action)

    const { payload } = action

    switch (action.type){

        case POST_UPDATE_BIRTH_INFOS_TIERS:
            next([
                apiRequest({body: payload.body, method: 'POST', url: payload.data, entity: POST_UPDATE_BIRTH_INFOS_TIERS, otherData: payload.otherData}),
                setLoader({state: true, entity: POST_UPDATE_BIRTH_INFOS_TIERS})
            ])
            break

        case `${POST_UPDATE_BIRTH_INFOS_TIERS} ${API_SUCCESS}`:
            next([
                setLoader({state: true, entity: CONTRACTS}),
                clearContracts(),
                setError({state: false, entity: POST_UPDATE_BIRTH_INFOS_TIERS}),
                setLoader({state: false, entity: POST_UPDATE_BIRTH_INFOS_TIERS}),
                setNotification({
                    entity: POST_UPDATE_BIRTH_INFOS_TIERS,
                    html: '<p>Vos informations seront mises à jour sous 24h</p>',
                    icon: 'success',
                    title: 'Félicitations !',
                    confirmButtonText: 'J\'ai compris',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    successFunction: payload.meta.otherData.successFunction
                })
            ])
            break

        case `${POST_UPDATE_BIRTH_INFOS_TIERS} ${API_ERROR}`:
            next([
                setError({state: true, entity: POST_UPDATE_BIRTH_INFOS_TIERS}),
                setLoader({state: false, entity: POST_UPDATE_BIRTH_INFOS_TIERS}),
                setNotification({
                    entity: POST_UPDATE_BIRTH_INFOS_TIERS,
                    html: '<p>Une erreur est survenue : ' + payload.data.response.data?.message ?? '' + '</p>',
                    icon: 'error',
                    title: 'Attention !',
                    confirmButtonText: 'J\'ai compris'
                })
            ])
            break

        default:
            break
    }
    return null
}
